import React from 'react';
import PropTypes from 'prop-types';

import { UncontrolledTable } from '~/components';

const MedicationTable = ({
  columns,
  defaultSorted,
  params,
  ...rest
}) => (
  <UncontrolledTable
    name="medication"
    endpoint={{
      url: 'data/public/nav-list-view-medication',
      params,
    }}
    columns={columns}
    defaultSorted={defaultSorted}
    {...rest}
  />
);

MedicationTable.propTypes = {
  params: PropTypes.shape(),
  columns: PropTypes.arrayOf(PropTypes.shape()),
  defaultSorted: PropTypes.arrayOf(PropTypes.shape()),
};

MedicationTable.defaultProps = {
  params: {},
  columns: [{
    id: 'medicationLabel',
    Header: 'Medication',
    accessor: 'attributes.medicationLabel',
  }, {
    id: 'medicationCategoryLabel',
    Header: 'Category',
    accessor: 'attributes.medicationCategoryLabel',
  }, {
    id: 'dosage',
    Header: 'Dosage',
    accessor: 'attributes.dosage',
  }, {
    id: 'frequency',
    Header: 'Frequency',
    accessor: 'attributes.frequency',
  }, {
    id: 'startedDate',
    Header: 'Started Date',
    accessor: 'attributes.startedDate',
    cellType: 'date',
  }, {
    id: 'finishedDate',
    Header: 'Finished Date',
    accessor: 'attributes.finishedDate',
    cellType: 'date',
  }, {
    id: 'isStillTaking',
    Header: 'Is Still Taking?',
    accessor: 'attributes.isStillTaking',
    cellType: 'choice',
  }, {
    id: 'comments',
    Header: 'Comments',
    accessor: 'attributes.comments',
  }],
  defaultSorted: [{ id: 'medicationLabel' }],
};

export default MedicationTable;
